import React, { useEffect, useRef } from 'react';

export function ProductionSetupDialog({ setup, characterName, open, onConfirm }) {
  const dialog = useRef(null);
  useEffect(() => {
    if (open && !dialog.current.open) dialog.current.showModal();
    else if (!open && dialog.current.open) dialog.current.close();
  }, [open]);
  return <dialog ref={dialog} className="production-setup-dialog" aria-labelledby="production-setup-title" onCancel={event => event.preventDefault()}>
    <div className="production-setup-content">
      <span className="eyebrow">Before the whole script · {characterName}</span>
      <h2 id="production-setup-title">Set up your production</h2>
      <p>{setup.title}</p>
      <p>Gather these once, then keep the props for later scenes nearby. Household substitutes are fine. You can also agree to mime any missing item.</p>
      <h3>Props for the whole production</h3>
      <ul>{setup.props.map(prop => <li key={prop.id}><strong>{prop.name}</strong><span>{prop.substitute}</span></li>)}</ul>
      <h3>Your optional costume</h3>
      <p>{setup.costume || 'Everyday clothes work; costumes are optional.'} Wear whatever lets you move comfortably.</p>
      <h3>Scene by scene</h3>
      {setup.scenes.map(scene => <section key={scene.id} className="production-setup-scene">
        <h4>Scene {scene.number}</h4>
        <p><strong>Setting:</strong> {scene.setting}</p>
        <p><strong>Have ready:</strong> {scene.props.map(id => setup.props.find(prop => prop.id === id)?.name).filter(Boolean).join(', ')}.</p>
        <p>{scene.staging}</p>
      </section>)}
    </div>
    <footer><button className="button primary wide" onClick={onConfirm}>I have the setup</button><small>Then finish your sound check and choose “I’m ready to act.” Your intro waits until the cast is ready.</small></footer>
  </dialog>;
}
